import { IGlobalItem } from '../types';
import { useForm } from 'react-hook-form';
import { ButtonContainer } from '../../ButtonContainer/ButtonContainer';
import { PrimaryButton, SecondaryButton } from '@weareopenr/component-library';
import { OptionGroupDetails } from 'src/components/CreateOptionGroupModal/OptionGroupDetails/OptionGroupDetails';
import { EntitySource, OptionGroupType } from 'src/constants';
import { IOptionGroupValues } from 'src/components/CreateOptionGroupModal/types';

interface IGlobalItemBundleCategoryProps {
  wizardItem: Partial<IGlobalItem>;
  onBackOrClose: () => void;
  onContinue: () => void;
  setGlobalItem: (data: Partial<IGlobalItem>) => void;
}

export const GlobalItemBundleCategory = ({
  wizardItem,
  onBackOrClose,
  onContinue,
  setGlobalItem,
}: IGlobalItemBundleCategoryProps) => {
  const formFields = useForm<IOptionGroupValues>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
    defaultValues: {
      source: EntitySource.LIBRARY,
      min_choices: 0,
      max_choices: 1,
      ranges: wizardItem.ranges || [],
      ...wizardItem.modifier_groups?.[0],
    },
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = formFields;

  const onFormSubmit = async (data: IOptionGroupValues) => {
    setGlobalItem({ modifier_groups: [data] });
    onContinue();
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <OptionGroupDetails useFormReturn={formFields} optionGroupType={OptionGroupType.BUNDLE} />

      <ButtonContainer
        left={
          <SecondaryButton type="button" size="full-width" buttonStyle="outline" onClick={onBackOrClose}>
            Back
          </SecondaryButton>
        }
        right={
          <PrimaryButton size="full-width" type="submit" loading={isSubmitting}>
            Continue
          </PrimaryButton>
        }
      />
    </form>
  );
};
